import { MdInsertLink } from 'react-icons/md';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetAnalytics, useGetEvent } from 'legacy/events/hooks';

import SettingsOption, { OptionType } from '../SettingsOption';

interface TrackingLinksSettingsProps {
  eventId: string;
  navigateToTrackingLinks: () => void;
}

const TrackingLinksSettings: React.FC<TrackingLinksSettingsProps> = ({
  eventId,
  navigateToTrackingLinks
}) => {
  const { t } = useTranslation(['events']);
  const { data: event } = useGetEvent(eventId);
  const { data: analytics } = useGetAnalytics(eventId, {
    enabled: event?.isOrganizer
  });

  return (
    <SettingsOption
      icon={<MdInsertLink size={20} />}
      title={t('events:settings.trackingLinks.title')}
      actionLabel={t('events:settings.trackingLinks.actionLabel')}
      onClick={navigateToTrackingLinks}
      value={
        analytics?.trackingLinks?.length
          ? t('events:settings.trackingLinks.totalCount', {
              count: analytics?.trackingLinks?.length
            })
          : ''
      }
      type={OptionType.Button}
    />
  );
};

export default TrackingLinksSettings;
